import React, {
    useCallback,
    useContext,
    useState,
} from 'react';
// import ScrollLock from 'react-scrolllock';

import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';
import { Transition } from 'react-transition-group';

import { Mobile } from 'app/components/Responsive';
import StreetInput from 'app/components/Form/Street';
import MobileStreet from 'app/views/MobileStreet';
import { analyticService } from 'global/services';

import {
    requestSuggestions, checkSuggestion,
} from 'app/utils/suggestions';
import { ConfigContext } from '../ConfigProvider';

import Modal from '../Modal';

import './address-select.scss';


const isDesktop = () => document.documentElement.clientWidth >= 1024;


export default function AddressSelect(props) {
    const {
        address,
        onChange,
        onSelect,
        placeholder,
        prepareAddressSuggestions =  null,
        // null позволяет вводить как московские, так и питерские адреса
        subdivision = null,
    } = props;

    const {
        value,
        validation: { errorText, hasError },
    } = address;

    const { pageId } = useContext(ConfigContext);
    const [inputState, setInputState] = useState({
        value: '',
        useLocalValue: false,
    });

    const [suggestions, setSuggestions] = useState([]);
    const [isAddressCorrect, setIsAdressCorrect] = useState(false);

    const [isMobileSelectOpen, setIsMobileSelectOpen] = useState(false);

    const toggleMobileSelect = () => {
        if (!isMobileSelectOpen) {
            analyticService.push({ eventName: 'Checkout_Click_Address', eventLocation: `/${pageId}` });
        }
        setIsMobileSelectOpen(!isMobileSelectOpen);
    };

    const fetchSuggestions = useCallback(throttle(async (nextValue) => {
        const {
            suggestions: fetchedSuggestions,
        } = await requestSuggestions({ query: nextValue }, subdivision);

        const nextSuggestions = prepareAddressSuggestions
            ? prepareAddressSuggestions(fetchedSuggestions)
            : fetchedSuggestions;

        setSuggestions(nextSuggestions);
    }, 500), []);

    const handleChangeAddress = useCallback((nextValue) => {
        onChange();
        fetchSuggestions(nextValue);
        setInputState({
            value: nextValue,
            useLocalValue: true,
        });
    }, [onChange, fetchSuggestions, setInputState]);

    const handleSelectStreet = async (addressData) => {
        if (addressData.data && !addressData.data.house) {
            handleChangeAddress(addressData.value);
            return;
        }

        const {
            data: {
                house_kladr_id: houseKladrId,
                house_fias_id: houseFiasId,
            },
        } = addressData;
        const isHouseFail = !houseKladrId || !houseFiasId;

        setIsAdressCorrect(isHouseFail);


        const { suggestions: [checkedAddress] } = await checkSuggestion({
            query: addressData.value,
        });
        if (!checkedAddress) return;

        toggleMobileSelect();
        onSelect(checkedAddress);

        setInputState({
            useLocalValue: false,
        });

        analyticService.push({
            eventName: 'Checkout_Close_Address_Popup',
            eventLocation: `/${pageId}`,
            result: isHouseFail ? 'failure' : 'success',
        });
    };

    const handleCloseMobileSelect = () => {
        analyticService.push({
            eventName: 'Checkout_Close_Address_Popup',
            eventLocation: `/${pageId}`,
            result: isAddressCorrect ? 'failure' : 'success',
        });
        toggleMobileSelect();
        if (!inputState.useLocalValue) return;

        onSelect({
            value: inputState.value,
            data: {},
        });
    };

    const inputValue = inputState.useLocalValue ? inputState.value : value;

    const mobileStreetInfo = {
        value: inputValue,
        street: address,
        onChange: handleChangeAddress,
        onSelect: handleSelectStreet,
        suggestions,
    };

    return (
        <div>
            <StreetInput
                value={inputValue}
                onChange={handleChangeAddress}
                onSelect={handleSelectStreet}
                suggestions={suggestions}
                onClick={toggleMobileSelect}
                disabled={isMobileSelectOpen && !isDesktop()}
                hasError={hasError && Boolean(errorText)}
                errorText={errorText}
                placeholder={placeholder}
            />

            <Mobile isWideMobile>
                <Transition
                    in={isMobileSelectOpen}
                    timeout={400}
                >
                    {(transitionState) => (
                        <Modal
                            transitionState={transitionState}
                            title="Улица, номер дома"
                            onClickClose={handleCloseMobileSelect}
                        >
                            {transitionState !== 'exited' && (
                                <div styleName="modal-content-wrap">
                                    <MobileStreet
                                        focusDelay={500}
                                        // hideDecoreations
                                        info={mobileStreetInfo}
                                        onClose={handleCloseMobileSelect}
                                    />
                                </div>
                            )}
                        </Modal>
                    )}
                </Transition>
            </Mobile>
            {/* {isMobileSelectOpen && <ScrollLock />} */}

        </div>
    );
}

AddressSelect.propTypes = {
    prepareAddressSuggestions: PropTypes.func,
    subdivision: PropTypes.string,
    address: PropTypes.shape({
        value: PropTypes.string,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
};
